import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerType } from 'src/app/enums/customer-type';
import { IWizard } from 'src/app/interfaces/iwizard';
import { WizardSteps } from 'src/app/interfaces/wizard-steps';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { GeneralService } from 'src/app/services/general.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-q-create-payment',
    templateUrl: './q-create-payment.component.html',
    styleUrls: ['./q-create-payment.component.scss'],
    standalone: false
})
export class QCreatePaymentComponent {
     isSubmitted: boolean = false;
     createSuccess: boolean = false;
     cdbID: string = "";
     errorsaving: boolean = false;
     customerType = CustomerType;
     companyInfo!: FormGroup;
     showEnrollError: boolean = false;

     constructor(public generalService: GeneralService,
          public enrollmentService: EnrollmentService,
          private modalService: NgbModal, private _router: Router) {
     }

     wizardObj: IWizard = {
          steps: [
               { step: 1, text: 'Welcome' } as WizardSteps,
               { step: 2, text: 'Company Information' } as WizardSteps,
               { step: 3, text: 'User Accounts' } as WizardSteps,
               { step: 4, text: 'Review' } as WizardSteps,
               { step: 5, text: 'Contract Documents' } as WizardSteps,
               { step: 6, text: 'Submit' } as WizardSteps,
               { step: 7, text: 'Billing Information' } as WizardSteps
          ]
     }

     ngOnInit(): void {
          this.companyInfo = new FormGroup({
               firstName: new FormControl(this.enrollmentService.newCustomer!.eulaAgreement?.agentFirstName, [
                    Validators.required,
                    Validators.maxLength(20),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ]),
               lastName: new FormControl(this.enrollmentService.newCustomer!.eulaAgreement?.agentLastName, [
                    Validators.required,
                    Validators.maxLength(20),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ]),
               title: new FormControl(this.enrollmentService.newCustomer!.eulaAgreement?.agentTitle, [
                    Validators.required,
                    Validators.maxLength(25),
                    Validators.pattern(/^([a-zA-Z ']*)$/)
               ])
          });
          setTimeout(() => this.scrollToTop(), 500);
     }

     get agentFirstName() { return this.companyInfo!.get('firstName'); }
     get agentLastName() { return this.companyInfo!.get('lastName'); }
     get agentTitle() { return this.companyInfo!.get('title'); }

     pageValid() {
          if (!this.companyInfo.valid) {
               return false
          }
          return (this.enrollmentService.newCustomer!.finalConsent?.agreesToConsent !== 'agree' ? false : true);
     }

     completeEnrollment() {
          this.isSubmitted = true;
          this.enrollmentService.newCustomer!.eulaAgreement!.agentFirstName = this.agentFirstName!.value;
          this.enrollmentService.newCustomer!.eulaAgreement!.agentLastName = this.agentLastName!.value;
          this.enrollmentService.newCustomer!.eulaAgreement!.agentTitle = this.agentTitle!.value;

          setTimeout(() => this.scrollToTop(), 500);

          if(!this.enrollmentService.inProcess){
               this.enrollmentService.inProcess = true;
               this.generalService.pageLogging("", "", "", "", "Starting Enrollment for:" + this.enrollmentService.newCustomer?.name).subscribe((v: any) => {})
               const enroll = this.enrollmentService.save();
               enroll.subscribe((v: any) => this.enrollState(v));
          }
     }

     enrollState(response: any) {
          if (response !== undefined) {
               this.createSuccess = response.status === 0
               this.isSubmitted = false;
               if (this.createSuccess) {

                    this.cdbID = response.customer.customerId;
                    this.generalService.pageLogging("CreatePayments", this.cdbID, "", "", "Enrolled:" + this.cdbID + "," + this.enrollmentService.newCustomer?.name).subscribe((v: any) => {})
                    this.enrollmentService.customerId = this.cdbID;
                    this._router.navigateByUrl('/signup/22');
               } else {
                    this.isSubmitted = false;
                    this.enrollmentService.EnrolledError = true;
                    this.generalService.pageLogging("CreatePayments", null, "", "Enrolled Error:" + this.enrollmentService.newCustomer?.name, response.message).subscribe((v: any) => { });
                    this._router.navigateByUrl('/signup/23')
               }
          } else {
               this.generalService.pageLogging("CreatePayments", null, "", "Enrolled Error:" + this.enrollmentService.newCustomer?.name, "Undefined response").subscribe((v: any) => {});
               this.isSubmitted = false;
               this.enrollmentService.EnrolledError = true;
               this._router.navigateByUrl('/signup/23');
          }
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     ngOnDestroy() {

     }

     ngAfterViewInit() {
          window.onbeforeunload = function () {
               return 'You have created an account but not set up billing. Are you sure you wish to exit?';
          }
     }
}
